export const mapBucketIds = bucket => {
  return {
    id: bucket.id,
    platform: bucket.bucket_type.platform.name,
    type: bucket.bucket_type.name.toLowerCase(),
  };
};
